import { render, staticRenderFns } from "./AccountBids.vue?vue&type=template&id=6327d5c0&scoped=true&"
import script from "./AccountBids.vue?vue&type=script&lang=js&"
export * from "./AccountBids.vue?vue&type=script&lang=js&"
import style0 from "./AccountBids.vue?vue&type=style&index=0&id=6327d5c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6327d5c0",
  null
  
)

export default component.exports